<div>
  <div class="modal-header modalHeaderDefault" style="margin-bottom: 10px;">
    <h6 class="modal-title"> {{ "EncounterListPage.cancel" | translate }}</h6>
    <span aria-label="Close" class="close" (click)="onNoClick()">
      <mat-icon matTooltip="{{ 'inventory.close' | translate }}"
        >clear</mat-icon
      >
    </span>
  </div>
<div *ngIf="isCancel">
  <mat-checkbox style="margin-left: 12px;"
  [checked]="openCharge" [disabled]="true">
  {{ "adt. ConvertToOut" | translate }}
   </mat-checkbox>
</div>
  
    <mat-form-field  style="padding-top: 10px; padding-bottom: 3px"
    class="fieldBox"
    appearance="outline">
      <mat-label> {{ "inventory.cancelReason" | translate }}</mat-label>
      <mat-select [(ngModel)]="cancelReason" name="Reason" required>
        <mat-option *ngFor="let reason of cancelReasons" [value]="reason.code">
          {{ reason.desc }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  
    <p style="padding-bottom: 5px;">
      <mat-form-field  class="fieldBox" appearance="outline">
        <mat-label>  {{ "EncounterListPage.remarks" | translate }} </mat-label>
        <input matInput placeholder="Remarks" [(ngModel)]="cancelNote" name = "remarks" pattern="[a-zA-Z0-9]+">
      </mat-form-field>
    </p> 
  </div>

  <div>
    <td style="float: right; padding-right: 5px; padding-bottom: 5px; padding-top: -10px;">
    <button
      mat-flat-button
      (click)="onNoClick()"
      class="btnRed"
      color="primary"
      matTooltip="{{ 'EncounterListPage.cancel' | translate }}" 
    >
    <mat-icon
            (click)="onNoClick()">clear</mat-icon>
  
    </button>
    </td>
    </div>
    <div>
      <td style="float: right; padding-right: 5px; padding-bottom: 5px; padding-top: -10px;"> 
    <button
      mat-flat-button
      class="btnGreen" color="primary"
      matTooltip="{{ 'AppointmentListPage.confirm' | translate }}" 
      (click)="SaveRemarks('yes')">
      <mat-icon >
      check</mat-icon>
    </button>

  </div>